import { TOAST_MESSAGES } from "../constants";
import { useState } from "react";
import toast from "react-hot-toast";
import { addPayroll, getPayroll, deletePayroll, getPayrollById, updatePayroll, getSalarySlips, getSalarySlipById ,updateSalarySlips, run_payroll, notifyDownloadSlips, uploadSalaryExcel, } from "../../../Services/payrollServices";
import { RESET_PAGINATION, GET_ALL_PAGINATION } from "../../../Constants/Strings";
import { getAllUsers } from "../../../Services/UserService";
import * as XLSX from "xlsx";
import { extractErrorMessage } from "../../../Utils/extractErrorMessage";

export const usePayroll = (initialFilters = { user: null }) => {
    const [loading, setLoading] = useState(false);
    const [filters, setFilters] = useState(initialFilters);

    const [pagination, setPagination] = useState(RESET_PAGINATION);
    const [payroll, setPayroll] = useState([]);

    const fetchPayroll = async (params) => {
        setLoading(true);
        try {
            const response = await getPayroll({
                ...filters,
                ...params,
                limit: params?.limit ?? pagination.limit,
                offset: params?.offset ?? pagination.offset,
            });
            if (response.status === 200) {
                const results = response.data?.results || [];

                setPagination({
                    limit: pagination.limit,
                    offset: response.data.offset ?? 0,
                    count: response.data.count ?? 0,
                });
                return results;
            }
        } catch (error) {
            toast.error(
                extractErrorMessage(error) || TOAST_MESSAGES.PAYROLL_FETCH_FAILED
            );
        } finally {
            setLoading(false);
        }
        return [];
    };

    const loadMorePayroll = async () => {
        if (pagination.offset >= pagination.count) return;

        const data = await fetchPayroll({ offset: pagination.offset });
        setPayroll(prev => [...prev, ...data]);
    };

    const createPayroll = async (formData) => {
        setLoading(true);

        try {
            const response = await addPayroll(formData);

            if (response.status === 201 || response.status === 200) {
                toast.success(TOAST_MESSAGES.PAYROLL_CREATED);
                return true;
            } else {
                toast.error(TOAST_MESSAGES.PAYROLL_CREATE_FAILED);
                return false;
            }

        } catch (error) {
            toast.error(
                extractErrorMessage(error) || TOAST_MESSAGES.PAYROLL_CREATE_FAILED
            );
            return false;
        } finally {
            setLoading(false);
        }
    };

    const removePayroll = async (id) => {
        setLoading(true);
        let success = false;
        try {
            const response = await deletePayroll(id);
            if (response.status === 204) {
                toast.success(TOAST_MESSAGES.SUCCESS_DELETE_PAYROLL);
                success = true;
            } else {
                const msg =
                    extractErrorMessage(response) || TOAST_MESSAGES.FAILED_DELETE_PAYROLL;
                toast.error(msg);
            }
        } catch (error) {
            toast.error(
                extractErrorMessage(error) || TOAST_MESSAGES.ERROR_DELETE_PAYROLL
            );
        } finally {
            setLoading(false);
            return success;
        }
    };

    const fetchPayrollById = async (id) => {
        setLoading(true);
        var data = null;
        try {
            const response = await getPayrollById(id);
            if (response.status === 200) {
                data = response.data;
            } else {
                const msg =
                    extractErrorMessage(response) ||
                    TOAST_MESSAGES.PAYROLL_FETCH_FAILED;
                toast.error(msg);
            }
        } catch (error) {
            toast.error(
                extractErrorMessage(error) || TOAST_MESSAGES.PAYROLL_FETCH_FAILED
            );
        } finally {
            setLoading(false);
            return data;
        }
    };

    const updatePayrollMaster = async (payrollId, payload) => {
        setLoading(true);
        var data = null;
        try {
            const response = await updatePayroll(payrollId, payload);
            if (response.status === 200) {
                data = response.data;
                const msg = TOAST_MESSAGES.UPDATE_PAYROLL_SUCCESS;
                toast.success(msg);
            } else {
                const msg =
                    extractErrorMessage(response) ||
                    TOAST_MESSAGES.UPDATE_PAYROLL_FAILED;
                toast.error(msg);
            }
        } catch (error) {
            toast.error(
                extractErrorMessage(error) || TOAST_MESSAGES.UPDATE_PAYROLL_FAILED
            );
        } finally {
            setLoading(false);
            return data;
        }
    };

    const fetchSalarySlips = async (params) => {
        setLoading(true);
        try {
            const response = await getSalarySlips({
                ...filters,
                ...params,
                limit: params?.limit ?? pagination.limit,
                offset: params?.offset ?? pagination.offset,
            });
            if (response.status === 200) {
                const results = response.data?.results || response.data || [];

                setPagination({
                    limit: params?.limit ?? pagination.limit,
                    offset: response.data.offset ?? 0,
                    count: response.data.count ?? 0,
                });
                return results;
            }
        } catch (error) {
            toast.error(
                extractErrorMessage(error) || TOAST_MESSAGES.SALARY_SLIPS_FETCH_FAILED
            );
        } finally {
            setLoading(false);
        }
        return [];
    };

    const loadMoreSalarySlips = async () => {
        if (pagination.offset >= pagination.count) return;

        const data = await fetchSalarySlips({ offset: pagination.offset });
        setPayroll(prev => [...prev, ...data]);
    };

    const fetchSalarySlipById = async (id) => {
        setLoading(true);
        var data = null;
        try {
            const response = await getSalarySlipById(id);
            if (response.status === 200) {
                data = response.data;
            } else {
                const msg =
                    extractErrorMessage(response) ||
                    TOAST_MESSAGES.SALARY_SLIPS_FETCH_FAILED;
                toast.error(msg);
            }
        } catch (error) {
            toast.error(
                extractErrorMessage(error) || TOAST_MESSAGES.SALARY_SLIPS_FETCH_FAILED
            );
        } finally {
            setLoading(false);
            return data;
        }
    };

    const updateSalarySlip = async (slipId, payload, options = {}) => {
        setLoading(true);
        var data = null;
        try {
            const finalPayload = { ...payload };
            if (options.action) {
                finalPayload.action = options.action;
            }
            const response = await updateSalarySlips(slipId, finalPayload);
            if (response.status === 200) {
                data = response.data;
                const msg = TOAST_MESSAGES.UPDATE_SALARY_SLIP_SUCCESS;
                toast.success(msg);
            } else {
                const msg =
                    extractErrorMessage(response) ||
                    TOAST_MESSAGES.UPDATE_SALARY_SLIP_FAILED;
                toast.error(msg);
            }
        } catch (error) {
            toast.error(
                extractErrorMessage(error) || TOAST_MESSAGES.UPDATE_SALARY_SLIP_FAILED
            );
        } finally {
            setLoading(false);
            return data;
        }
    };

    const addSalarySlip = async ({ month }) => {
        setLoading(true);

        try {
            const response = await run_payroll({ month });
            if (response.status === 200) {
                toast.success(TOAST_MESSAGES.SALARY_SLIPS_FETCH);
                return true;
            } else {
                toast.error(TOAST_MESSAGES.SALARY_SLIPS_FETCH_FAILED);
                return false;
            }

        } catch (error) {
            toast.error(
                extractErrorMessage(error) || TOAST_MESSAGES.SALARY_SLIPS_FETCH_FAILED
            );
            return false;
        } finally {
            setLoading(false);
        }
    };

    const notifyDownloadSalarySlip = async (id) => {
        setLoading(true);
        var data = null;
        try {
            const response = await notifyDownloadSlips(id);
            if (response.status === 200) {
                data = response.data;
            } else {
                const msg =
                    extractErrorMessage(response) ||
                    TOAST_MESSAGES.NOTIFICATION_FAILED;
                toast.error(msg);
            }
        } catch (error) {
            toast.error(
                extractErrorMessage(error) || TOAST_MESSAGES.NOTIFICATION_FAILED
            );
        } finally {
            setLoading(false);
            return data;
        }
    };

    const downloadSampleTemplate = async () => {
        setLoading(true);
        try {
            const res = await getAllUsers({ ...GET_ALL_PAGINATION, is_active: true });
            const userList = res?.data?.results || res?.data || [];
            const activeUsers = Array.isArray(userList)
                ? userList.filter((u) => u.is_active !== false)
                : [];

            const now = new Date();
            const defaultMonth = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, "0")}`;

            const SAMPLE_COLUMNS = [
                "Month",
                "First Name",
                "Last Name",
                "Email",
                "Number",
                "Basic Amount",
                "HRA",
                "Conveyance Allowance",
                "Medical Allowance",
                "LTA Allowance",
                "Attire Allowance",
                "Bonus",
                "Gross",
                "Employee PF",
                "Employer PF",
                "Employee ESIC",
                "Employer ESIC",
                "Employee MLWF",
                "Employer MLWF",
                "PT",
                "TDS",
                "Referral Bonus",
                "Reimbursements",
                "Other Adjustments",
                "Total Deductions",
                "Net",
                "Remark",
            ];

            let rows = activeUsers.map((u) => ({
                "Month": defaultMonth,
                "First Name": u.first_name || "",
                "Last Name": u.last_name || "",
                "Email": u.email || "",
                "Number": u.mobile || "",
                "Basic Amount": "",
                "HRA": "",
                "Conveyance Allowance": "",
                "Medical Allowance": "",
                "LTA Allowance": "",
                "Attire Allowance": "",
                "Bonus": "",
                "Gross": "",
                "Employee PF": "",
                "Employer PF": "",
                "Employee ESIC": "",
                "Employer ESIC": "",
                "Employee MLWF": "",
                "Employer MLWF": "",
                "PT": "",
                "TDS": "",
                "Referral Bonus": "",
                "Reimbursements": "",
                "Other Adjustments": "",
                "Total Deductions": "",
                "Net": "",
                "Remark": "",
            }));

            if (rows.length === 0) {
                rows = [
                    {
                        "Month": defaultMonth,
                        "First Name": "Sample",
                        "Last Name": "User",
                        "Email": "sample.user@example.com",
                        "Number": "9876543210",
                        "Basic Amount": 30000,
                        "HRA": 12000,
                        "Conveyance Allowance": 1600,
                        "Medical Allowance": 1250,
                        "LTA Allowance": 0,
                        "Attire Allowance": 0,
                        "Bonus": 500,
                        "Gross": 45350,
                        "Employee PF": 3000,
                        "Employer PF": 3000,
                        "Employee ESIC": 0,
                        "Employer ESIC": 0,
                        "Employee MLWF": 0,
                        "Employer MLWF": 0,
                        "PT": 200,
                        "TDS": 500,
                        "Referral Bonus": 0,
                        "Reimbursements": 0,
                        "Other Adjustments": 0,
                        "Total Deductions": 3700,
                        "Net": 41650,
                        "Remark": "Sample",
                    },
                ];
            }

            const worksheet = XLSX.utils.json_to_sheet(rows, { header: SAMPLE_COLUMNS });
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, "Salary Slips");
            XLSX.writeFile(
                workbook,
                `salary_slip_sample_${new Date().toISOString().slice(0, 10)}.xlsx`
            );
            toast.success("Sample template downloaded successfully.");
        } catch (error) {
            toast.error(
                extractErrorMessage(error) || "Failed to download sample template."
            );
        } finally {
            setLoading(false);
        }
    };

    const uploadSalaryWorkbook = async (file) => {
        if (!file) return false;
        setLoading(true);
        try {
            const response = await uploadSalaryExcel(file);
            const count = response.data?.count ?? 0;
            const errors = response.data?.errors || [];

            if (response.status === 201 || response.status === 200) {
                if (count > 0 && errors.length === 0) {
                    toast.success(`Successfully uploaded and created ${count} salary slip(s).`);
                } else if (count > 0 && errors.length > 0) {
                    toast.success(`Successfully saved ${count} salary slip(s).`);
                    if (errors.length <= 3) {
                        errors.forEach((err) => toast.error(err, { duration: 7000 }));
                    } else {
                        const firstFew = errors.slice(0, 3).join("\n");
                        toast.error(
                            `Errors in ${errors.length} row(s):\n${firstFew}\n...and ${errors.length - 3} more.`,
                            { duration: 8000 }
                        );
                    }
                } else {
                    toast.error(response.data?.detail || "No salary slips created.");
                }
                return count > 0;
            } else {
                toast.error(
                    extractErrorMessage(response) || "Failed to upload salary slips."
                );
                return false;
            }
        } catch (error) {
            const errorData = error?.response?.data;
            if (errorData?.errors && Array.isArray(errorData.errors) && errorData.errors.length > 0) {
                if (errorData.errors.length <= 3) {
                    errorData.errors.forEach((err) => toast.error(err, { duration: 7000 }));
                } else {
                    const firstFew = errorData.errors.slice(0, 3).join("\n");
                    toast.error(
                        `Errors in ${errorData.errors.length} row(s):\n${firstFew}\n...and ${errorData.errors.length - 3} more.`,
                        { duration: 8000 }
                    );
                }
            } else {
                toast.error(
                    extractErrorMessage(error) || "Failed to upload salary slips."
                );
            }
            return false;
        } finally {
            setLoading(false);
        }
    };

    return {
        loading,
        filters,
        setFilters,
        pagination,
        setPagination,
        fetchPayroll,
        loadMorePayroll,
        payroll,
        setPayroll,
        createPayroll,
        removePayroll,
        fetchPayrollById,
        updatePayrollMaster,
        fetchSalarySlips,
        loadMoreSalarySlips,
        fetchSalarySlipById,
        updateSalarySlip,
        addSalarySlip,
        notifyDownloadSalarySlip,
        downloadSampleTemplate,
        uploadSalaryWorkbook,
    };
};